import React from 'react';

const AdminOrderNFTs: React.FC = (): JSX.Element => {
    return <>AdminOrderNFTs</>;
};

export default AdminOrderNFTs;
